/*
 * @file 滚动至顶部组件
 * @author xuhongliang
 */

import React from 'react';
import {withRouter} from 'react-router';

class ScrollToTop extends React.PureComponent {

	constructor(props, context) {
		super(props, context);
		this.scrollTopList = {};
	}
	componentDidMount(){
		// console.log(this.props);
		// this.handleScrollTop(this.props.history.action);
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.props.location.pathname !== prevProps.location.pathname) {
			this.handleScrollTop(this.props.history.action);
		}
	}

	handleScrollTop = (action)=>{
		switch (action){
			case 'POP':
				let top = this.scrollTopList[this.props.location.pathname];
				if(top){
					window.scrollTo(0,top);
				}
				break;
			case 'PUSH':
				window.scrollTo(0, 0);
				break;
			case 'REPLACE':
				break;
			default:
				break;
		}
	};

	getSnapshotBeforeUpdate(prevProps, prevState){
		let top = document.documentElement.scrollTop;
		this.scrollTopList[prevProps.location.pathname] = top;
		return top;
	}

	render() {
		return this.props.children || null;
	}

}

export default withRouter(ScrollToTop);



// WEBPACK FOOTER //
// ./src/components/public/scrollToTop/scrollToTop.js